export default __webpack_public_path__ + "static/media/reporta.69710f18.png";